import { render, staticRenderFns } from "./UsageChart.vue?vue&type=template&id=b8f0530a&scoped=true&"
import script from "./UsageChart.vue?vue&type=script&lang=js&"
export * from "./UsageChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8f0530a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/bamboo/xml-data/build-dir/WWW-WWW-JOB1/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b8f0530a')) {
      api.createRecord('b8f0530a', component.options)
    } else {
      api.reload('b8f0530a', component.options)
    }
    module.hot.accept("./UsageChart.vue?vue&type=template&id=b8f0530a&scoped=true&", function () {
      api.rerender('b8f0530a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/src/components/myaccount/usage/UsageChart.vue"
export default component.exports